module.exports = __webpack_public_path__ + "_/img/MapMarker6_Red.79dde5be.svg";